/* eslint-disable react-hooks/exhaustive-deps*/
import { useEffect, useState } from 'react'

export const useCheckScrolled = () => {
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 0
      if (scrolled !== isScrolled) setIsScrolled(scrolled)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [isScrolled])

  useEffect(() => {
    const scrolled = window.scrollY > 0
    if (scrolled !== isScrolled) setIsScrolled(scrolled)
  }, [])

  return { isScrolled }
}
